import { NgModule } from '@angular/core'
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core'
import {
  userAccountTranslationChunksConfig,
  userAccountTranslationsDe,
  userAccountTranslationsEn,
  userAccountTranslationsJa,
  userAccountTranslationsZh
} from '@spartacus/user/account/assets'
import { UserAccountRootModule, USER_ACCOUNT_FEATURE } from '@spartacus/user/account/root'
import { UserProfileCoreModule } from '@spartacus/user/profile/core'
import { UserProfileOccModule } from '@spartacus/user/profile/occ'
import { UserProfileRootModule, USER_PROFILE_FEATURE } from '@spartacus/user/profile/root'

@NgModule({
  declarations: [],
  imports: [
    UserAccountRootModule,
    UserProfileRootModule,
    UserProfileCoreModule,
    UserProfileOccModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [USER_ACCOUNT_FEATURE]: {
          module: () => import('@spartacus/user/account').then(m => m.UserAccountModule)
        },
        [USER_PROFILE_FEATURE]: {
          module: () =>
            import('@spartacus/user/profile/components').then(m => m.UserProfileComponentsModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {
          en: userAccountTranslationsEn,
          ja: userAccountTranslationsJa,
          de: userAccountTranslationsDe,
          zh: userAccountTranslationsZh
        },
        chunks: userAccountTranslationChunksConfig
      }
    } as I18nConfig)
  ]
})
export class UserFeatureModule {}
